export const SET_MENU_LIST = 'SET_MENU_LIST'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_EXPIRATION = 'SET_EXPIRATION'
export const SET_USER_PROJECT = 'SET_USER_PROJECT'
export const SET_WHITE_YEAR_MONTH = 'SET_WHITE_YEAR_MONTH'
export const SET_WHITE_YEAR_MONTH_NAME = 'SET_WHITE_YEAR_MONTH_NAME'
export const SET_WHITE_LIST_IS_OPEN = 'SET_WHITE_LIST_IS_OPEN'
export const SET_WHITE_SUPPLEMENTARY_OPEN = 'SET_WHITE_SUPPLEMENTARY_OPEN'
export const SET_CURRENT_PHASE = 'SET_CURRENT_PHASE'
export const SET_AUDIT_OPEN = 'SET_AUDIT_OPEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_MENU_LIST_CHANGE = 'SET_MENU_LIST_CHANGE'
export const SET_PROJECT = 'SET_PROJECT'
export const SET_PROJECT_URL = 'SET_PROJECT_URL'
export const SET_BUSINESS_TYPE = 'SET_BUSINESS_TYPE'
export const SET_PROJECT_WHITE_ENTITY = 'SET_PROJECT_WHITE_ENTITY'
export const SET_IS_OPEN_EDIT_HISTORY = 'SET_IS_OPEN_EDIT_HISTORY'
export const SET_SUPPLEMENT_BATCH = 'SET_SUPPLEMENT_BATCH'

export const SET_INVOICE_START = 'SET_INVOICE_START'
export const SET_INVOICE_END = 'SET_INVOICE_END'
export const SET_INVOICE_RESTRICTION_START = 'SET_INVOICE_RESTRICTION_START'
export const SET_INVOICE_RESTRICTION_END = 'SET_INVOICE_RESTRICTION_END'

export const SET_COMMON_BATCH_ENTITY = 'SET_COMMON_BATCH_ENTITY'
export const SET_SUPPLEMENT_BATCH_ENTITY = 'SET_SUPPLEMENT_BATCH_ENTITY'

export const SET_PRIVATEKEY = 'SET_PRIVATEKEY'
export const SET_USER_ROLE = 'SET_USER_ROLE'

